'use client';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';
import React from 'react';
import { useState } from 'react';

export default function ArchiveContentDesc({ content }) {
  const [showMore, setShowMore] = useState(false);
  return (
    <div className="archiveDescription desc text-sm md:text-base mt-4 relative pb-12 overflow-hidden leading-9 text-justify">
      <div
        className={`font-light overflow-hidden ${
          showMore ? 'h-auto' : 'h-[600px]'
        }`}
      >
        <div dangerouslySetInnerHTML={{ __html: content }} />
        <div
          className="flex text-sm mt-4 absolute bottom-0 z-10 cursor-pointer flex items-center"
          onClick={() => setShowMore(!showMore)}
        >
          <span className="text-sm font-bold text-ocean-blue">
            {showMore ? 'بستن' : 'مشاهده بیشتر'}
          </span>
          <SmallArrowDown fill="#2A75BB" />
        </div>
      </div>
    </div>
  );
}
